export const getNumberOfPagesFromBase64PDF = (base64Data: string) => {
   // Extract the content of the PDF, excluding the data URI prefix
   const pdfContent = atob(base64Data.split(',')[1]);

   // Use a regular expression to count the number of pages
   const numPages = (pdfContent.match(/\/Type\s*\/Page\b/g) || []).length;

   return numPages;
};
